import { CognitoIdentityProviderClient } from '@aws-sdk/client-cognito-identity-provider';
import { loadConfig } from '../config';

// Cognito configuration for direct SDK usage
export let cognitoConfig: {
  userPoolId: string;
  userPoolClientId: string;
  region: string;
} | null = null;

// Load Cognito config from runtime config - NO FALLBACKS
// Returns true if config was loaded successfully, false otherwise
export async function loadCognitoConfig(): Promise<boolean> {
  const config = await loadConfig();

  if (!config.cognito) {
    cognitoConfig = null;
    return false;
  }

  if (!config.cognito.userPoolId || !config.cognito.userPoolClientId) {
    cognitoConfig = null;
    return false;
  }

  cognitoConfig = {
    userPoolId: config.cognito.userPoolId,
    userPoolClientId: config.cognito.userPoolClientId,
    region: config.cognito.region || 'us-east-1',
  };

  // Create the Cognito client with the loaded config
  cognitoClient = new CognitoIdentityProviderClient({
    region: cognitoConfig.region,
  });

  // Store on window for easy access
  (window as any).__COGNITO_CONFIG = cognitoConfig;
  return true;
}

// Create Cognito client instance - will be updated when config is loaded
export let cognitoClient: CognitoIdentityProviderClient;

// Authentication state management
export interface AuthState {
  isAuthenticated: boolean;
  user: any;
  session: string | null;
  challengeName: string | null;
}

// Challenge types we'll handle
export enum ChallengeType {
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
  MFA_SETUP = 'MFA_SETUP',
  SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
  SMS_MFA = 'SMS_MFA',
}

// Utility functions for authentication
export const authUtils = {
  // Store authentication tokens
  storeTokens: (tokens: any) => {
    if (tokens.AccessToken) {
      sessionStorage.setItem('cognito_access_token', tokens.AccessToken);
    }
    if (tokens.RefreshToken) {
      sessionStorage.setItem('cognito_refresh_token', tokens.RefreshToken);
    }
    if (tokens.IdToken) {
      sessionStorage.setItem('cognito_id_token', tokens.IdToken);
    }
  },

  // Get stored tokens
  getTokens: () => ({
    accessToken: sessionStorage.getItem('cognito_access_token'),
    refreshToken: sessionStorage.getItem('cognito_refresh_token'),
    idToken: sessionStorage.getItem('cognito_id_token'),
  }),

  // Clear stored tokens
  clearTokens: () => {
    sessionStorage.removeItem('cognito_access_token');
    sessionStorage.removeItem('cognito_refresh_token');
    sessionStorage.removeItem('cognito_id_token');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const accessToken = sessionStorage.getItem('cognito_access_token');
    return !!accessToken;
  },
};
export const CACHE_BUST = Date.now();
